import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const AdditionalDocumentsCell = memo(({ needsIcon, icon, color = 'grey500' }) => {
  return (
    !!needsIcon && (
      <div>
        <Icon glyph={icon} size="1.8rem" color={color} />
      </div>
    )
  );
});

AdditionalDocumentsCell.propTypes = {
  needsIcon: PropTypes.bool,
};

export default AdditionalDocumentsCell;
